import {
  ApiRoute,
  CheckInTicket,
  Ticket,
  TicketDetail,
  TicketDetailSchema,
  TicketSchema,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class TicketApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.TICKET),
      requireAuth: true
    });
  }

  async getTicketById(ticketId: string): Promise<TicketDetail> {
    return await this.get(ticketId, TicketDetailSchema, {
      requireAuth: true
    });
  }

  async checkIn(data: CheckInTicket): Promise<Ticket> {
    return await this.post("check-in", TicketSchema, data, { requireAuth: true });
  }
}

export const ticketApiClient = new TicketApiClient();
